import React from 'react'
import { csx } from '@vtex/admin-ui'

// [TODO]<internationalization>: KM hardcoded
const getPickupDistance = (distance: SLA['pickupDistance']) => {
  return distance ? `${distance.toFixed(1)} km` : '0 km'
}

const getDistanceLabelColor = (
  currentPickupId: Optional<string>,
  selectedPickupId: Optional<string>
) => ({
  color: currentPickupId === selectedPickupId ? '$blue40' : '$primary',
})

export type DistanceLabelProps = {
  sla: SLA
  selectedSlaId: Optional<string>
}

export const DistanceLabel = ({ sla, selectedSlaId }: DistanceLabelProps) => (
  <p className={csx(getDistanceLabelColor(sla.id, selectedSlaId))}>
    {getPickupDistance(sla.pickupDistance)}
  </p>
)
